 
// import React, { useEffect, useState } from "react";
// import "../students/student.css";
// import {
//   Container,
//   Row,
//   Col,
//   Button,
//   Badge,
//   Image,
//   Card,
//   Nav,
//   ListGroup,
//   Spinner,
//   Carousel,
//   CarouselItem,
//   CarouselCaption,
// } from "react-bootstrap";
// import { useNavigate, Link, useLocation } from "react-router-dom";
// import DefaultLayout from "../../../layout/vendor/DefaultLayout";
// import { IoArrowBackSharp } from "react-icons/io5";
// import { IoMdLink } from "react-icons/io";
// import {
//   FaCaretRight,
//   FaCaretDown,
//   FaArrowLeft,
//   FaArrowRight,
//   FaFileArchive,
//   FaFilePdf,
//   FaFileImage,
//   FaFileWord,
//   FaFileExcel,
//   FaFile,
// } from "react-icons/fa";
// import { ImFilePdf } from "react-icons/im";
// import RejectApproval from "../../../components/vendor/RejectApproval";
// import Success from "../../../components/vendor/Success";
// import api from "../../../utils/helper";
// import { useMutation, useQuery, useQueryClient } from "react-query";
// import AddCourse from "../../courses/AddCourse";
// import moment from "moment";
// import { BadgesComponent } from "../../../components/BadgeRenderer";
// import { URLS } from "../../../utils/URL";
// import { useAlerts } from "../../../context/AlertContext";
// import { FiDownload } from "react-icons/fi";

// const ApprovalList = () => {
//   const [students, setStudents] = useState([]);

//   const [openDelete, setOpenDelete] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedLesson, setSelectedLesson] = useState(null);
//   const [selectedModule, setSelectedModule] = useState(null);
//   const queryClient = useQueryClient();
//   const [activeSlideIndex, setActiveSlideIndex] = useState(0);

//   const [moduleLoading, setModuleLoading] = useState(false);

//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const location = useLocation();
//   const course = location.state?.course;

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentStudents = students.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(students.length / itemsPerPage);

//   const { showSuccess, showError } = useAlerts();

//   const handleReject = (rejectData) => {
//     // setShowFailure(reject);

//     rejectCourseMutation.mutate(rejectData);
//   };

//   const handleSuccess = () => {
//     approveCourseMutation.mutate();
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleLessonClick = (index) => {
//     setSelectedLesson(selectedLesson === index ? null : index);
//     setSelectedModule(null);
//   };

//   const handleModuleClick = (lessonID, moduleID) => {
//     console.log(lessonID, moduleID, "oki");
//     setModuleLoading(true);

//     queryClient.invalidateQueries(["module", lessonID, moduleID]);

//     queryClient
//       .fetchQuery(["module", lessonID, moduleID], () =>
//         api.get(`/lessons/${lessonID}/modules/${moduleID}`)
//       )
//       .then((response) => {
//         console.log("Module data:", response);

//         setSelectedModule(response?.data?.data);
//         setModuleLoading(false);
//       })
//       .catch((error) => {
//         setModuleLoading(false);
//         console.error("Error fetching module data:", error);
//       });
//   };

//   const handleSelect = (selectedIndex) => {
//     setActiveSlideIndex(selectedIndex);
//   };

//   const goToPrev = (slideArr) => {
//     if (slideArr?.length) {
//       const totalSlides = slideArr.length;
//       const newIndex =
//         activeSlideIndex === 0 ? totalSlides - 1 : activeSlideIndex - 1;
//       setActiveSlideIndex(newIndex);
//     }
//   };

//   const goToNext = (slideArr) => {
//     if (slideArr?.length) {
//       const totalSlides = slideArr?.length;
//       const newIndex =
//         activeSlideIndex === totalSlides - 1 ? 0 : activeSlideIndex + 1;
//       setActiveSlideIndex(newIndex);
//     }
//   };

//   const goToSlide = (slideIndex) => {
//     setActiveSlideIndex(slideIndex);
//   };

//   const handleDownload = async (url, name) => {
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = name;
//     link.target = "_blank"; // optional
//     link.rel = "noopener noreferrer"; // security
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     // try {
//     //   const response = await fetch(url, {
//     //     mode: "cors",
//     //   });
//     //   const blob = await response.blob();
//     //   const link = document.createElement("a");
//     //   link.href = window.URL.createObjectURL(blob);
//     //   link.download = name;
//     //   link.click();
//     // } catch (err) {
//     //   console.error("Download failed:", err);
//     // }
//   };

//   const getCurrentModuleContent = (module) => {
//     if (module) {
//       return (
//         <div className="module-content">
//           <h4 className="mb-3">{module.name}</h4>

//           {module.ppt && (
//             <div className="carousel-container">
//               {module?.slideImages?.length !== 0 && (
//                 <Carousel
//                   activeIndex={activeSlideIndex}
//                   onSelect={handleSelect}
//                   controls={false}
//                   indicators={false}
//                   interval={null} // This disables auto-sliding
//                 >
//                   {module?.slideImages?.map((slide, index) => (
//                     <CarouselItem key={index} className="text-center">
//                       <div className="aspect-ratio-container">
//                         <img
//                           // className="d-block w-100"
//                           className="carousel-img"
//                           src={URLS.MAIN + slide}
//                           alt={`Slide ${index + 1}`}
//                         />
//                       </div>
//                       <CarouselCaption></CarouselCaption>
//                     </CarouselItem>
//                   ))}
//                 </Carousel>
//               )}

//               {module?.slideImages?.length > 0 && (
//                 <div className="carousel-navigation d-flex justify-content-between mt-3">
//                   <Button
//                     onClick={() => goToPrev(module?.slideImages)}
//                     // className="mx-2"
//                     variant="outline-dark"
//                     className="btn-sec px-1  "
//                   >
//                     <FaArrowLeft /> Previous
//                   </Button>

//                   {/* Indicator Buttons */}

//                   <div className=" d-flex justify-content-center mx-2 align-items-center">
//                     {module?.slideImages?.map((_, slideIndex) => (
//                       <div
//                         key={slideIndex}
//                         onClick={() => goToSlide(slideIndex)}
//                         className={`mx-1 text-center ${activeSlideIndex === slideIndex
//                           ? "pri-dot"
//                           : "sec-dot"
//                           }`}
//                       >
//                         <span style={{ color: "#ffffff" }}>
//                           {" "}
//                           {activeSlideIndex === slideIndex
//                             ? slideIndex + 1 + "/" + module?.slideImages?.length
//                             : ""}{" "}
//                         </span>
//                       </div>
//                     ))}
//                   </div>

//                   <Button
//                     onClick={() => goToNext(module?.slideImages)}
//                     variant="primary"
//                     className="btn-sec  px-1 "
//                   >
//                     Next <FaArrowRight className="mx-1" />
//                   </Button>
//                 </div>
//               )}

//               <style jsx>{`
//                 .carousel-container {
//                   margin-bottom: 30px;
//                 }
//                 .carousel-navigation {
//                   margin-top: 20px;
//                 }
//                 .aspect-ratio-container {
//                   position: relative;
//                   width: 100%;
//                   padding-top: 56.25%; /* 16:9 Aspect Ratio (9 / 16 = 0.5625 or 56.25%) */
//                   overflow: hidden;
//                 }
//                 .carousel-img {
//                   position: absolute;
//                   top: 0;
//                   left: 0;
//                   width: 100%;
//                   height: 100%;
//                   object-fit: contain;
//                   background-color: #f5f5f5;
//                 }
//                 .carousel-navigation {
//                   margin-top: 20px;
//                 }
//               `}</style>
//             </div>
//           )}

//           <div className="mb-3">
//             <h5>Summary</h5>
//             <p>{module.summary}</p>
//           </div>

//           {module.content && (
//             <div className="mb-3">
//               <h5>Content</h5>
//               <div dangerouslySetInnerHTML={{ __html: module.content }} />
//             </div>
//           )}

//           {module.attachments && module.attachments.length > 0 && (
//             <div className="mb-3">
//               <h5>Attachments</h5>
//               <div className="row">
//                 {module.attachments.map((attachment, idx) => {
//                   const fileUrl = URLS.IMG_URL + attachment.file;
//                   const fileName = attachment.filename || "Attachment";
//                   const fileExtension = fileName.split(".").pop().toLowerCase();
//                   const displayName =
//                     fileName.length > 20
//                       ? fileName.substring(0, 20) + "..."
//                       : fileName;
//                   const fileIcons = {
//                     zip: (
//                       <FaFileArchive
//                         className="text-secondary me-3"
//                         size={30}
//                       />
//                     ),
//                     pdf: <FaFilePdf className="text-danger me-3" size={30} />,
//                     jpg: <FaFileImage className="text-info me-3" size={30} />,
//                     jpeg: <FaFileImage className="text-info me-3" size={30} />,
//                     png: <FaFileImage className="text-info me-3" size={30} />,
//                     doc: <FaFileWord className="text-primary me-3" size={30} />,
//                     docx: (
//                       <FaFileWord className="text-primary me-3" size={30} />
//                     ),
//                     xls: (
//                       <FaFileExcel className="text-success me-3" size={30} />
//                     ),
//                     xlsx: (
//                       <FaFileExcel className="text-success me-3" size={30} />
//                     ),
//                   };

//                   const icon = fileIcons[fileExtension] || (
//                     <FaFile className="text-secondary me-3" size={30} />
//                   );

//                   return (
//                     <div key={idx} className="col-md-3 col-sm-6 mb-4">
//                       <div className="attachment-hover-wrapper position-relative">
//                         <Card className="p-3 text-center attachment-card shadow-sm border rounded">
//                           <div className="mb-2">{icon}</div>
//                           <div className="fw-semibold full-name mb-1 text-truncate">
//                             {displayName}
//                           </div>
//                           <div className="text-muted small mb-2">
//                             {fileExtension.toUpperCase()}
//                           </div>

//                           <button
//                             onClick={() => handleDownload(fileUrl, fileName)}
//                             className="btn btn-outline-light btn-sm download-button"
//                             style={{ border: "none" }}
//                           >
//                             <FiDownload size={16} />
//                           </button>
//                           <div className="hover-overlay">
//                             <div className="full-name">{fileName}</div>
//                           </div>
//                         </Card>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           {module.links && module.links.length > 0 && (
//             <div className="mb-3">
//               <h5>Links</h5>
//               <div className="row g-2">
//                 {module.links.map((link, idx) => {
//                   const url = typeof link === "string" ? link : link.link;
//                   const displayUrl =
//                     url.length > 35 ? url.substring(0, 32) + "..." : url;
//                   const icon = (
//                     <IoMdLink className="text-primary me-2" size={20} />
//                   );

//                   return (
//                     <div key={idx} className="col-md-6 mb-2">
//                       <Card className="d-flex flex-row align-items-center p-2">
//                         {icon}
//                         <a
//                           href={url.startsWith("http") ? url : `https://${url}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="text-decoration-none text-truncate"
//                           title={url}
//                         >
//                           {displayUrl}
//                         </a>
//                       </Card>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     }

//     return (
//       <div className="text-center p-5">
//         <p className="text-muted">Select a module to view its content</p>
//       </div>
//     );
//   };

//   const {
//     data: lessons,
//     isLoading,
//     error,
//   } = useQuery(["lessons", { id: course._id }], () =>
//     api.get(`/lessons/course/${course._id}`)
//   );

//   const rejectCourseMutation = useMutation(
//     (courseData) =>
//       api.put(`/vendors/courses/${course._id}/reject`, courseData),
//     {
//       onSuccess: (response) => {
//         console.log(response, "response");
//         showSuccess("Course rejected successfully");
//         setOpenDelete(false);
//         navigate("/vendor/approvals");
//       },
//       onError: (error) => {
//         showError(
//           error.response?.data?.message ||
//           "Failed to reject course. Please try again."
//         );
//       },
//     }
//   );

//   const approveCourseMutation = useMutation(
//     () => api.put(`/vendors/courses/${course._id}/approve`),
//     {
//       onSuccess: (response) => {
//         console.log(response, "response");
//         showSuccess(response.data?.message || "Course approved successfully");
//         navigate("/vendor/approvals");
//       },
//       onError: (error) => {
//         showError(
//           error.response?.data?.message ||
//           "Failed to approve course. Please try again."
//         );
//       },
//     }
//   );

//   return (
//     <>
//       <DefaultLayout>
//         <div className="bgNav d-block d-lg-none px-1 position-relative pb-4">
//           <div className="d-flex align-items-center justify-content-start mb-2">
//             <Link
//               to="/vendor/approvals"
//               style={{ color: "none", textDecoration: "transparent" }}
//             >
//               <Button variant="light mb-3 ms-2">
//                 <IoArrowBackSharp size={20} />
//               </Button>
//             </Link>
//           </div>
//         </div>
//         <Container
//           fluid
//           className="main-container mt-0 mt-md-4 ps-auto ps-md-0"
//         >
//           <Card className="form-card">
//             {/* Header Section */}
//             <Card.Header className="heading card-border-none p-2 px-4">
//               <div className="d-flex justify-content-between align-items-center approval-header">
//                 <Link
//                   to="/vendor/approvals"
//                   style={{ color: "none", textDecoration: "transparent" }}
//                 >
//                   <Button
//                     variant="outline-dark"
//                     className="btn-sec me-2 fw-bold d-none d-lg-block"
//                   >
//                     <IoArrowBackSharp size={20} /> Back
//                   </Button>
//                 </Link>
//                 <p className="mb-0 textpara fw-500 font-14 text-danger d-none d-lg-block">
//                   To be approved in: {course.approvalTimeRemaining}
//                 </p>

//                 <p className="mb-0 textpara fw-500 font-12 p-1 pb-3 text-danger d-block d-md-none">
//                   To be approved in:  {course.approvalTimeRemaining}
//                 </p>

//                 <div className="text-end d-flex">
//                   <Button
//                     variant="danger"
//                     className="me-2 btn-sec"
//                     onClick={() => setOpenDelete(true)}
//                     disabled={
//                       rejectCourseMutation.isLoading ||
//                       approveCourseMutation.isLoading
//                     }
//                   >
//                     {rejectCourseMutation.isLoading ? (
//                       <Spinner animation="border" size="sm" className="me-1" />
//                     ) : null}
//                     Reject
//                   </Button>
//                   <Button
//                     variant="success"
//                     className="me-2 btn-sec"
//                     onClick={handleSuccess}
//                     disabled={
//                       rejectCourseMutation.isLoading ||
//                       approveCourseMutation.isLoading
//                     }
//                   >
//                     {approveCourseMutation.isLoading ? (
//                       <Spinner animation="border" size="sm" className="me-1" />
//                     ) : null}
//                     Approve
//                   </Button>
//                 </div>
//               </div>
//             </Card.Header>

//             <Card.Body className="px-0 px-md-5 pt-2">
//               <div className="d-none d-md-block">
//                 <Image
//                   src={
//                     course.cover_img
//                       ? URLS.IMG_URL + course.cover_img
//                       : "/images/image.png"
//                   }
//                   className="approval-banner"
//                   style={{
//                     objectFit: "cover",
//                     // width: "100%",
//                     // height: "auto",
//                     // maxHeight: "500px",
//                   }}
//                 />
//                 <div className="centered-text text-light">
//                   <h2 className="mb-1 fw-bold">{course.name}</h2>
//                   <p className="mb-0 bold-600 text-line-height">
//                     Duration: {course.duration}
//                   </p>
//                   <p className="mb-0 bold-200">
//                     Created on: {moment(course.createdAt).format("DD/MM/YYYY")}
//                   </p>
//                 </div>
//                 <div className="position-absolute img-lables">
//                   <div className="d-flex justify-content-between mt-1">
//                     <BadgesComponent badges={course.tags} />
//                   </div>
//                 </div>
//               </div>

//               <div className="d-block d-lg-none position-relative">
//                 <Image
//                   src={
//                     course.cover_img
//                       ? URLS.IMG_URL + course.cover_img
//                       : "/images/bike-gradient.jpeg"
//                   }
//                   className="approval-banner mx-n4 w-100"
//                 />
//                 <div className="centered-text text-light">
//                   <h2 className="mb-1 fw-bold">{course.name}</h2>
//                   <p className="mb-0 bold-600 text-line-height">
//                     Duration: {course.duration}
//                   </p>
//                   <p className="mb-0 bold-200">
//                     Created on: {moment(course.createdAt).format("DD/MM/YYYY")}
//                   </p>
//                 </div>
//                 <div className="position-absolute img-lables">
//                   <div className="d-flex justify-content-between mt-1">
//                     <BadgesComponent badges={course.tags} />
//                   </div>
//                 </div>
//               </div>

//               <div className="p-4 font-16 fw-500">
//                 <p>{course.about}</p>
//               </div>

//               {/* Implement the lesson/module list here */}
//               {lessons?.data?.data?.length != 0 && (
//                 <div className="shadow-sm p-3">
//                   <Row>
//                     {/* Left side: List of lessons and modules (1/4 width) */}
//                     <Col md={3} className="border-end mb-3">
//                       <h5 className="mb-3">Course Content</h5>
//                       <ListGroup variant="flush">
//                         {lessons?.data?.data &&
//                           lessons?.data?.data?.map((lesson, lessonIndex) => (
//                             <div key={lesson._id}>
//                               <ListGroup.Item
//                                 action
//                                 className={`d-flex justify-content-between align-items-center ${selectedLesson === lessonIndex ? "active" : ""
//                                   }`}
//                                 onClick={() =>
//                                   handleLessonClick(lessonIndex, lesson._id)
//                                 }
//                               >
//                                 <div>
//                                   {/* <span className="me-2">{lessonIndex + 1}:</span> */}
//                                   {lesson.name}
//                                 </div>
//                                 {lesson.modules &&
//                                   lesson.modules.length > 0 &&
//                                   (selectedLesson === lessonIndex ? (
//                                     <FaCaretDown />
//                                   ) : (
//                                     <FaCaretRight />
//                                   ))}
//                               </ListGroup.Item>

//                               {/* Show modules when lesson is selected */}
//                               {selectedLesson === lessonIndex &&
//                                 lesson.modules &&
//                                 lesson.modules.length > 0 && (
//                                   <ListGroup
//                                     variant="flush"
//                                     className="ps-4 bg-light"
//                                   >
//                                     {lesson.modules.map(
//                                       (module, moduleIndex) => (
//                                         <ListGroup.Item
//                                           key={module._id || moduleIndex}
//                                           action
//                                           className={`border-0 py-2 ${selectedModule === moduleIndex &&
//                                             selectedLesson === lessonIndex
//                                             ? "active"
//                                             : ""
//                                             }`}
//                                           onClick={() =>
//                                             handleModuleClick(
//                                               lesson._id,
//                                               module._id
//                                             )
//                                           }
//                                         >
//                                           <div className="d-flex align-items-center">
//                                             {/* <span className="me-2">•</span> */}
//                                             {module.name}
//                                           </div>
//                                         </ListGroup.Item>
//                                       )
//                                     )}
//                                   </ListGroup>
//                                 )}
//                             </div>
//                           ))}
//                       </ListGroup>
//                     </Col>

//                     {/* Right side: Module content (3/4 width) */}
//                     <Col md={9}>
//                       {moduleLoading ? (
//                         <div className="text-center p-5">
//                           <p className="text-muted">
//                             Please wait! Your presentation is being ready
//                           </p>
//                           <Spinner animation="border" size="md" />
//                         </div>
//                       ) : (
//                         getCurrentModuleContent(selectedModule)
//                       )}
//                     </Col>
//                   </Row>
//                 </div>
//               )}
//             </Card.Body>
//           </Card>
//         </Container>
//       </DefaultLayout>

//       <RejectApproval
//         show={openDelete}
//         close={() => setOpenDelete(false)}
//         title="Reject content"
//         reject={handleReject}
//         isLoading={rejectCourseMutation.isLoading}
//       />
//     </>
//   );
// };

// export default ApprovalList;


//----------------------------------------------------------------------------------------New progress implementation



import React, { useEffect, useState } from "react";
import "../students/student.css";
import {
  Container,
  Row,
  Col,
  Button,
  Badge,
  Image,
  Card,
  Nav,
  ListGroup,
  Spinner,
  Carousel,
  CarouselItem,
  CarouselCaption,
  ProgressBar,
} from "react-bootstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import { IoArrowBackSharp } from "react-icons/io5";
import { IoMdLink } from "react-icons/io";
import {
  FaCaretRight,
  FaCaretDown,
  FaArrowLeft,
  FaArrowRight,
  FaFileArchive,
  FaFilePdf,
  FaFileImage,
  FaFileWord,
  FaFileExcel,
  FaFile,
} from "react-icons/fa";
import { ImFilePdf } from "react-icons/im";
import RejectApproval from "../../../components/vendor/RejectApproval";  
import api from "../../../utils/helper";
import { useMutation, useQuery, useQueryClient } from "react-query";
import AddCourse from "../../courses/AddCourse";
import moment from "moment";
import { BadgesComponent } from "../../../components/BadgeRenderer";
import { URLS } from "../../../utils/URL";
import { useAlerts } from "../../../context/AlertContext";
import { FiDownload } from "react-icons/fi";

// Custom hook for progress simulation
const useSimulatedProgress = (isLoading, duration = 12000) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval = null;
    
    if (isLoading) {
      setProgress(0);
      const totalSteps = duration / 600; // Update every 600ms
      let currentStep = 0;

      interval = setInterval(() => {
        currentStep++;
        // Exponential decay to slow down near the end
        const newProgress = 90 * (1 - Math.exp(-4 * currentStep / totalSteps));
        setProgress(Math.min(newProgress, 90));
      }, 600);
    } else if (isLoading === false) {
      // Complete progress when loading is done
      setProgress(100);
      setTimeout(() => setProgress(0), 1000); // Reset after 1 second
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isLoading, duration]);

  return Math.round(progress);
};

const ApprovalList = () => {

  const [openDelete, setOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const queryClient = useQueryClient();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const [moduleLoading, setModuleLoading] = useState(false);
  
  // Use the custom hook for progress simulation
  const progress = useSimulatedProgress(moduleLoading, 12000); // 12 seconds estimated

  const itemsPerPage = 10;
  const navigate = useNavigate();
  const location = useLocation();
  const course = location.state?.course;

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const { showSuccess, showError } = useAlerts();

  const handleReject = (rejectData) => {
    // setShowFailure(reject);

    rejectCourseMutation.mutate(rejectData);
  };

  const handleSuccess = () => {
    approveCourseMutation.mutate();
  };

  const handleLessonClick = (index) => {
    setSelectedLesson(selectedLesson === index ? null : index);
    setSelectedModule(null);
  };

  const handleModuleClick = (lessonID, moduleID) => {
    console.log(lessonID, moduleID, "oki");
    setModuleLoading(true);

    queryClient.invalidateQueries(["module", lessonID, moduleID]);

    queryClient
      .fetchQuery(["module", lessonID, moduleID], () =>
        api.get(`/lessons/${lessonID}/modules/${moduleID}`)
      )
      .then((response) => {
        console.log("Module data:", response);

        setSelectedModule(response?.data?.data);
        setModuleLoading(false);
      })
      .catch((error) => {
        setModuleLoading(false);
        console.error("Error fetching module data:", error);
      });
  };

  const handleSelect = (selectedIndex) => {
    setActiveSlideIndex(selectedIndex);
  };

  const goToPrev = (slideArr) => {
    if (slideArr?.length) {
      const totalSlides = slideArr.length;
      const newIndex =
        activeSlideIndex === 0 ? totalSlides - 1 : activeSlideIndex - 1;
      setActiveSlideIndex(newIndex);
    }
  };

  const goToNext = (slideArr) => {
    if (slideArr?.length) {
      const totalSlides = slideArr?.length;
      const newIndex =
        activeSlideIndex === totalSlides - 1 ? 0 : activeSlideIndex + 1;
      setActiveSlideIndex(newIndex);
    }
  };

  const goToSlide = (slideIndex) => {
    setActiveSlideIndex(slideIndex);
  };

  const handleDownload = async (url, name) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    link.target = "_blank"; // optional
    link.rel = "noopener noreferrer"; // security
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  };

  const getCurrentModuleContent = (module) => {
    if (module) {
      return (
        <div className="module-content">
          <h4 className="mb-3">{module.name}</h4>

          {/* {module.ppt && ( */}
            <div className="carousel-container">
              {module?.slideImages?.length !== 0 && (
                <Carousel
                  activeIndex={activeSlideIndex}
                  onSelect={handleSelect}
                  controls={false}
                  indicators={false}
                  interval={null} // This disables auto-sliding
                >
                  {module?.slideImages?.map((slide, index) => (
                    <CarouselItem key={index} className="text-center">
                      <div className="aspect-ratio-container">
                        <img
                          // className="d-block w-100"
                          className="carousel-img"
                          src={slide}
                          alt={`Slide ${index + 1}`}
                        />
                      </div>
                      <CarouselCaption></CarouselCaption>
                    </CarouselItem>
                  ))}
                </Carousel>
              )}

              {module?.slideImages?.length > 0 && (
                <div className="carousel-navigation d-flex justify-content-between mt-3">
                  <Button
                    onClick={() => goToPrev(module?.slideImages)}
                    // className="mx-2"
                    variant="outline-dark"
                    className="btn-sec px-1  "
                  >
                    <FaArrowLeft /> Previous
                  </Button>

                  {/* Indicator Buttons */}

                  <div className=" d-flex justify-content-center mx-2 align-items-center">
                    {module?.slideImages?.map((_, slideIndex) => (
                      <div
                        key={slideIndex}
                        onClick={() => goToSlide(slideIndex)}
                        className={`mx-1 text-center ${activeSlideIndex === slideIndex
                          ? "pri-dot"
                          : "sec-dot"
                          }`}
                      >
                        <span style={{ color: "#ffffff" }}>
                          {" "}
                          {activeSlideIndex === slideIndex
                            ? slideIndex + 1 + "/" + module?.slideImages?.length
                            : ""}{" "}
                        </span>
                      </div>
                    ))}
                  </div>

                  <Button
                    onClick={() => goToNext(module?.slideImages)}
                    variant="primary"
                    className="btn-sec  px-1 "
                  >
                    Next <FaArrowRight className="mx-1" />
                  </Button>
                </div>
              )}

              <style jsx>{`
                .carousel-container {
                  margin-bottom: 30px;
                }
                .carousel-navigation {
                  margin-top: 20px;
                }
                .aspect-ratio-container {
                  position: relative;
                  width: 100%;
                  padding-top: 56.25%; /* 16:9 Aspect Ratio (9 / 16 = 0.5625 or 56.25%) */
                  overflow: hidden;
                }
                .carousel-img {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  background-color: #f5f5f5;
                }
                .carousel-navigation {
                  margin-top: 20px;
                }
              `}</style>
            </div>
          {/* )} */}

          <div className="mb-3">
            <h5>Summary</h5>
            <p>{module.summary}</p>
          </div>

          {module.content && (
            <div className="mb-3">
              <h5>Content</h5>
              <div dangerouslySetInnerHTML={{ __html: module.content }} />
            </div>
          )}

          {module.attachments && module.attachments.length > 0 && (
            <div className="mb-3">
              <h5>Attachments</h5>
              <div className="row">
                {module.attachments.map((attachment, idx) => {
                  const fileUrl = URLS.IMG_URL + attachment.file;
                  const fileName = attachment.filename || "Attachment";
                  const fileExtension = fileName.split(".").pop().toLowerCase();
                  const displayName =
                    fileName.length > 20
                      ? fileName.substring(0, 20) + "..."
                      : fileName;
                  const fileIcons = {
                    zip: (
                      <FaFileArchive
                        className="text-secondary me-3"
                        size={30}
                      />
                    ),
                    pdf: <FaFilePdf className="text-danger me-3" size={30} />,
                    jpg: <FaFileImage className="text-info me-3" size={30} />,
                    jpeg: <FaFileImage className="text-info me-3" size={30} />,
                    png: <FaFileImage className="text-info me-3" size={30} />,
                    doc: <FaFileWord className="text-primary me-3" size={30} />,
                    docx: (
                      <FaFileWord className="text-primary me-3" size={30} />
                    ),
                    xls: (
                      <FaFileExcel className="text-success me-3" size={30} />
                    ),
                    xlsx: (
                      <FaFileExcel className="text-success me-3" size={30} />
                    ),
                  };

                  const icon = fileIcons[fileExtension] || (
                    <FaFile className="text-secondary me-3" size={30} />
                  );

                  return (
                    <div key={idx} className="col-md-3 col-sm-6 mb-4">
                      <div className="attachment-hover-wrapper position-relative">
                        <Card className="p-3 text-center attachment-card shadow-sm border rounded">
                          <div className="mb-2">{icon}</div>
                          <div className="fw-semibold full-name mb-1 text-truncate">
                            {displayName}
                          </div>
                          <div className="text-muted small mb-2">
                            {fileExtension.toUpperCase()}
                          </div>

                          <button
                            onClick={() => handleDownload(fileUrl, fileName)}
                            className="btn btn-outline-light btn-sm download-button"
                            style={{ border: "none" }}
                          >
                            <FiDownload size={16} />
                          </button>
                          <div className="hover-overlay">
                            <div className="full-name">{fileName}</div>
                          </div>
                        </Card>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {module.links && module.links.length > 0 && (
            <div className="mb-3">
              <h5>Links</h5>
              <div className="row g-2">
                {module.links.map((link, idx) => {
                  const url = typeof link === "string" ? link : link.link;
                  const displayUrl =
                    url.length > 35 ? url.substring(0, 32) + "..." : url;
                  const icon = (
                    <IoMdLink className="text-primary me-2" size={20} />
                  );

                  return (
                    <div key={idx} className="col-md-6 mb-2">
                      <Card className="d-flex flex-row align-items-center p-2">
                        {icon}
                        <a
                          href={url.startsWith("http") ? url : `https://${url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none text-truncate"
                          title={url}
                        >
                          {displayUrl}
                        </a>
                      </Card>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="text-center p-5">
        <p className="text-muted">Select a module to view its content</p>
      </div>
    );
  };

  const {
    data: lessons,
    isLoading,
    error,
  } = useQuery(["lessons", { id: course._id }], () =>
    api.get(`/lessons/course/${course._id}`)
  );

  const rejectCourseMutation = useMutation(
    (courseData) =>
      api.put(`/vendors/courses/${course._id}/reject`, courseData),
    {
      onSuccess: (response) => {
        console.log(response, "response");
        showSuccess("Course rejected successfully");
        setOpenDelete(false);
        navigate("/vendor/approvals");
      },
      onError: (error) => {
        showError(
          error.response?.data?.message ||
          "Failed to reject course. Please try again."
        );
      },
    }
  );

  const approveCourseMutation = useMutation(
    () => api.put(`/vendors/courses/${course._id}/approve`),
    {
      onSuccess: (response) => {
        console.log(response, "response");
        showSuccess(response.data?.message || "Course approved successfully");
        navigate("/vendor/approvals");
      },
      onError: (error) => {
        showError(
          error.response?.data?.message ||
          "Failed to approve course. Please try again."
        );
      },
    }
  );

  return (
    <>
      <DefaultLayout>
        <div className="bgNav d-block d-lg-none px-1 position-relative pb-4">
          <div className="d-flex align-items-center justify-content-start mb-2">
            <Link
              to="/vendor/approvals"
              style={{ color: "none", textDecoration: "transparent" }}
            >
              <Button variant="light mb-3 ms-2">
                <IoArrowBackSharp size={20} />
              </Button>
            </Link>
          </div>
        </div>
        <Container
          fluid
          className="main-container mt-0 mt-md-4 ps-auto ps-md-0"
        >
          <Card className="form-card">
            {/* Header Section */}
            <Card.Header className="heading card-border-none p-2 px-4">
              <div className="d-flex justify-content-between align-items-center approval-header">
                <Link
                  to={location.state.viewOnly ? "/vendor/courses" :"/vendor/approvals"}
                  style={{ color: "none", textDecoration: "transparent" }}
                >
                  <Button
                    variant="outline-dark"
                    className="btn-sec me-2 fw-bold d-none d-lg-block"
                  >
                    <IoArrowBackSharp size={20} /> Back
                  </Button>
                </Link>
          {location.state.viewOnly ? null :
          <>
                <p className="mb-0 textpara fw-500 font-14 text-danger d-none d-lg-block">
                  To be approved in: {course.approvalTimeRemaining}
                </p>

                <p className="mb-0 textpara fw-500 font-12 p-1 pb-3 text-danger d-block d-md-none">
                  To be approved in:  {course.approvalTimeRemaining}
                </p>

                <div className="text-end d-flex">
                  <Button
                    variant="danger"
                    className="me-2 btn-sec"
                    onClick={() => setOpenDelete(true)}
                    disabled={
                      rejectCourseMutation.isLoading ||
                      approveCourseMutation.isLoading
                    }
                  >
                    {rejectCourseMutation.isLoading ? (
                      <Spinner animation="border" size="sm" className="me-1" />
                    ) : null}
                    Reject
                  </Button>
                  <Button
                    variant="success"
                    className="me-2 btn-sec"
                    onClick={handleSuccess}
                    disabled={
                      rejectCourseMutation.isLoading ||
                      approveCourseMutation.isLoading
                    }
                  >
                    {approveCourseMutation.isLoading ? (
                      <Spinner animation="border" size="sm" className="me-1" />
                    ) : null}
                    Approve
                  </Button>
                </div>
</>}
              </div>
            </Card.Header>

            <Card.Body className="px-0 px-md-5 pt-2">
              <div className="d-none d-md-block">
                <Image
                  src={
                    course.cover_img
                      ? URLS.IMG_URL + course.cover_img
                      : "/images/image.png"
                  }
                  className="approval-banner"
                  style={{
                    objectFit: "cover",
                    // width: "100%",
                    // height: "auto",
                    // maxHeight: "500px",
                  }}
                />
                <div className="centered-text text-light">
                  <h2 className="mb-1 fw-bold">{course.name}</h2>
                  <p className="mb-0 bold-600 text-line-height">
                    Duration: {course.duration}
                  </p>
                  <p className="mb-0 bold-200">
                    Created on: {moment(course.createdAt).format("DD/MM/YYYY")}
                  </p>
                </div>
                <div className="position-absolute img-lables">
                  <div className="d-flex justify-content-between mt-1">
                    <BadgesComponent badges={course.tags} />
                  </div>
                </div>
              </div>

              <div className="d-block d-lg-none position-relative">
                <Image
                  src={
                    course.cover_img
                      ? URLS.IMG_URL + course.cover_img
                      : "/images/bike-gradient.jpeg"
                  }
                  className="approval-banner mx-n4 w-100"
                />
                <div className="centered-text text-light">
                  <h2 className="mb-1 fw-bold">{course.name}</h2>
                  <p className="mb-0 bold-600 text-line-height">
                    Duration: {course.duration}
                  </p>
                  <p className="mb-0 bold-200">
                    Created on: {moment(course.createdAt).format("DD/MM/YYYY")}
                  </p>
                </div>
                <div className="position-absolute img-lables">
                  <div className="d-flex justify-content-between mt-1">
                    <BadgesComponent badges={course.tags} />
                  </div>
                </div>
              </div>

              <div className="p-4 font-16 fw-500">
                <p>{course.about}</p>
              </div>

              {/* Implement the lesson/module list here */}
              {lessons?.data?.data?.length != 0 && (
                <div className="shadow-sm p-3">
                  <Row>
                    {/* Left side: List of lessons and modules (1/4 width) */}
                    <Col md={3} className="border-end mb-3">
                      <h5 className="mb-3">Course Content</h5>
                      <ListGroup variant="flush">
                        {lessons?.data?.data &&
                          lessons?.data?.data?.map((lesson, lessonIndex) => (
                            <div key={lesson._id}>
                              <ListGroup.Item
                                action
                                className={`d-flex justify-content-between align-items-center ${selectedLesson === lessonIndex ? "active" : ""
                                  }`}
                                onClick={() =>
                                  handleLessonClick(lessonIndex, lesson._id)
                                }
                              >
                                <div>
                                  {/* <span className="me-2">{lessonIndex + 1}:</span> */}
                                  {lesson.name}
                                </div>
                                {lesson.modules &&
                                  lesson.modules.length > 0 &&
                                  (selectedLesson === lessonIndex ? (
                                    <FaCaretDown />
                                  ) : (
                                    <FaCaretRight />
                                  ))}
                              </ListGroup.Item>

                              {/* Show modules when lesson is selected */}
                              {selectedLesson === lessonIndex &&
                                lesson.modules &&
                                lesson.modules.length > 0 && (
                                  <ListGroup
                                    variant="flush"
                                    className="ps-4 bg-light"
                                  >
                                    {lesson.modules.map(
                                      (module, moduleIndex) => (
                                        <ListGroup.Item
                                          key={module._id || moduleIndex}
                                          action
                                          className={`border-0 py-2 ${selectedModule === moduleIndex &&
                                            selectedLesson === lessonIndex
                                            ? "active"
                                            : ""
                                            }`}
                                          onClick={() =>
                                            handleModuleClick(
                                              lesson._id,
                                              module._id
                                            )
                                          }
                                        >
                                          <div className="d-flex align-items-center">
                                            {/* <span className="me-2">•</span> */}
                                            {module.name}
                                          </div>
                                        </ListGroup.Item>
                                      )
                                    )}
                                  </ListGroup>
                                )}
                            </div>
                          ))}
                      </ListGroup>
                    </Col>

                    {/* Right side: Module content (3/4 width) */}
                    <Col md={9}>
                      {moduleLoading ? (
                        <div className="text-center p-4">
                          <div className="mb-3">
                            <p className="text-muted mb-2">
                              Please wait! Your presentation is being ready
                            </p>
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <span className="me-2 text-primary fw-semibold">
                                {progress}%
                              </span>
                              <Spinner animation="border" size="sm" className="text-primary" />
                            </div>
                          </div>
                          
                          {/* Progress Bar */}
                          <div className="w-100" style={{ maxWidth: '400px', margin: '0 auto' }}>
                            <ProgressBar 
                              now={progress} 
                              variant="primary"
                              style={{ height: '8px' }}
                              className="mb-2"
                            />
                            <small className="text-muted">
                              Processing images and content...
                            </small>
                          </div>
                        </div>
                      ) : (
                        getCurrentModuleContent(selectedModule)
                      )}
                    </Col>
                  </Row>
                </div>
              )}
            </Card.Body>
          </Card>
        </Container>
      </DefaultLayout>

      <RejectApproval
        show={openDelete}
        close={() => setOpenDelete(false)}
        title="Reject content"
        reject={handleReject}
        isLoading={rejectCourseMutation.isLoading}
      />
    </>
  );
};

export default ApprovalList;